import { useEffect } from 'react';

export function useTabHotkeys({ tabs, activeTabId, onSwitch, onCreate, onClose }) {
  useEffect(() => {
    const handler = (e) => {
      const tag = document.activeElement?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      const sorted = [...tabs].sort((a, b) => a.order - b.order);

      if (e.altKey && !e.ctrlKey && !e.shiftKey && e.key === 'n') {
        // Alt+N — new tab
        e.preventDefault();
        onCreate();
      } else if (e.altKey && !e.ctrlKey && !e.shiftKey && e.key === 'w') {
        // Alt+W — close active tab
        e.preventDefault();
        if (tabs.length > 1) {
          const tab = tabs.find(t => t.id === activeTabId);
          if (window.confirm(`Close tab "${tab?.label ?? 'this tab'}"?`)) onClose(activeTabId);
        }
      } else if (e.ctrlKey && !e.altKey && !e.shiftKey && e.key === ']') {
        // Ctrl+] — next tab
        e.preventDefault();
        const idx = sorted.findIndex(t => t.id === activeTabId);
        const next = sorted[(idx + 1) % sorted.length];
        if (next) onSwitch(next.id);
      } else if (e.ctrlKey && !e.altKey && !e.shiftKey && e.key === '[') {
        // Ctrl+[ — previous tab
        e.preventDefault();
        const idx = sorted.findIndex(t => t.id === activeTabId);
        const prev = sorted[(idx - 1 + sorted.length) % sorted.length];
        if (prev) onSwitch(prev.id);
      } else if (e.ctrlKey && !e.altKey && !e.shiftKey && e.key >= '1' && e.key <= '9') {
        // Ctrl+1-9 — jump to tab by position
        e.preventDefault();
        const idx = parseInt(e.key) - 1;
        if (sorted[idx]) onSwitch(sorted[idx].id);
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [tabs, activeTabId, onSwitch, onCreate, onClose]);
}
